import React, { memo } from 'react';
import PropTypes from 'prop-types';

import { compose } from 'redux';
import { connect } from 'react-redux';

import { useInjectReducer } from 'utils/injectReducer';
import { useInjectSaga } from 'utils/injectSaga';

import saga from './saga';
import reducer from './reducer';

export function Email({ children }) {
  useInjectSaga({ key: 'emailProvider', saga });
  useInjectReducer({ key: 'emailProvider', reducer });

  return React.Children.only(children);
}

Email.propTypes = {
  children: PropTypes.element,
};

const withConnect = connect();

export { default as useEmail } from './useEmail';
export default compose(withConnect, memo)(Email);
